import React from "react";
import term from "../assets/footerimage/termcondition.png";
import { Link } from "react-router-dom";
import hero from "../assets/footerimage/Term-&-Conditions.png";
import { Helmet } from "react-helmet-async";
const TermsCondition = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Deetyasoft IVR & Cloud Solutions</title>
        <meta
          name="description"
          content="Review Deetyasoft’s Terms & Conditions for IVR, cloud communication solutions. Understand your rights, usage rules, and service agreements."
        />
        <meta
          name="keywords"
          content="Deetyasoft terms, IVR service terms, cloud solutions policy, service agreement Deetyasoft, IVR usage conditions, cloud telephony rules"
        />
        <link
          rel="canonical"
          href="https://deetyasoft.com/terms-and-conditions"
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://deetyasoft.com/terms-and-conditions"
        />
        <meta
          property="og:title"
          content="Terms & Conditions | Deetyasoft IVR & Cloud Solutions"
        />
        <meta
          property="og:description"
          content="Review Deetyasoft’s Terms & Conditions for IVR, cloud communication solutions. Understand your rights, usage rules, and service agreements."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/termcondition.88bd3e56914a5231cc78.png"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/terms-and-conditions"
        />
        <meta
          name="twitter:title"
          content="Terms & Conditions | Deetyasoft IVR & Cloud Solutions"
        />
        <meta
          name="twitter:description"
          content="Review Deetyasoft’s Terms & Conditions for IVR, cloud communication solutions. Understand your rights, usage rules, and service agreements."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/termcondition.88bd3e56914a5231cc78.png"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* <!-- Id+json scripts --> */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Organization",
              name: "Deetya Soft Pvt Ltd",
              description:
                "Review Deetyasoft’s Terms & Conditions for IVR, cloud communication solutions. Understand your rights, usage rules, and service agreements.",
              image:
                "https://deetyasoft.com/static/media/termcondition.88bd3e56914a5231cc78.png",
              logo: "https://www.deetyasoft.com/images/logo.png",
              url: "https://www.deetyasoft.com",
              telephone: ["+91-9015350505", "+91-9717055088"],
              email: "info@deetyasoft.com",
              sameAs: [
                "https://www.linkedin.com/company/deetya-soft-private-limited",
                "https://www.facebook.com/deetyasoftprivatelimited",
                "https://www.instagram.com/deetyasoft",
                "https://www.youtube.com/@deetyasoft",
                "https://www.crunchbase.com/organization/deetyasoft",
              ],
              address: {
                "@type": "PostalAddress",
                streetAddress:
                  "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
                addressLocality: "Ghaziabad",
                addressRegion: "Uttar Pradesh",
                postalCode: "201014",
                addressCountry: "IN",
              },
            }),
          }}
        />

        {/* Contact Points */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Organization",
              url: "https://www.deetyasoft.com",
              contactPoint: [
                {
                  "@type": "ContactPoint",
                  telephone: "+91-981-862-7588",
                  contactType: "technical support",
                  areaServed: "IN",
                },
                {
                  "@type": "ContactPoint",
                  telephone: "+91-901-535-0505",
                  contactType: "sales",
                  areaServed: "IN",
                },
              ],
            }),
          }}
        />

        {/* Review Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "Parshan ",
              },
              reviewBody:
                "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
              url: "https://www.deetyasoft.com/",
              description:
                "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
              datePublished: "2025-06-17",
              name: "Deetya Soft Pvt Ltd",
              reviewRating: {
                "@type": "Rating",
                worstRating: "1",
                ratingValue: "5",
                bestRating: "5",
              },
              itemReviewed: {
                "@type": "Organization",
                name: "Deetya Soft Pvt Ltd",
              },
            }),
          }}
        />
      </Helmet>
      <img src={hero} alt="" className="h-full w-full" />
      <div className="relative z-10 flex flex-col justify-center items-end h-full px-6 md:px-16 text-white">
        <div className="flex items-center space-x-2 text-sm md:text-base">
          <Link to="/" className="text-black hover:underline font-bold">
            Home
          </Link>
          <span className="text-red-500">●</span>
          <span className="text-main1"> Terms and Conditions</span>
        </div>
      </div>
      {/* another all the content */}
      <div className="max-w-6xl mx-auto px-4 py-4 md:py-6 text-gray-800">
        <h2 className="text-2xl sm:text-3xl font-semibold  text-orangeheading mb-2 md:mb-2">
          Terms and Conditions
        </h2>
        <div className="w-full h-[2px]  bg-orangeheading rounded mt-3 mb-6" />

        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8  rounded-lg mb-6">
          {/* Text Left */}
          <div className="w-full md:w-1/2 ">
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-main1">
              1. Introduction
            </h2>
            <p className="text-sm md:text-base leading-relaxed">
              Deetya Soft Pvt Ltd. is an IT solution provider for varied
              services in application development, website designing, mobile
              application, development campaigning solutions and SU solutions.
              The motive of our company is to build quality products employed
              with the latest technology for ultimate customer satisfaction.
              Deetya Soft is rising gradually with leaps and turns to new
              heights in the field of Web Development and end to end solutions.
              The innovators of our company are committed to dedicated research
              for bringing solutions that justifies the new era of technology.
              Building quality products by our technical experts is the mantra
              followed at Deetya Soft. Every member of our company is inscribed
              with corporate values of working as a team towards a common goal.
              We have developed products and provided services for many
              companies in real estate, Telecom, commercial product
              organizations and management firms. It takes ages to be the best
              in our field but we are good in what we do to provide the best.
            </p>
          </div>

          {/* Image Right */}
          <div className="w-full md:w-1/2">
            <img
              src={term}
              alt="term-and-condition"
              className="w-full h-auto max-h-[400px] object-contain rounded-lg shadow"
            />
          </div>
        </div>

        <div className="mb-4">
          <h2 className="md:text-xl text-main1 text-lg font-semibold mb-1">
            2. General working
          </h2>
          <p className="md:text-base text-sm">
            Deetya Soft Private Limited lets user receive incoming calls through
            a virtual number (landline number or mobile number) or a toll-free
            number on an IVR and offer various options like playing message,
            routing to department, recording of calls etc. Deetya Soft Private
            Limited also offers outbound calls or features like click to call to
            allow customers to connect to any person generating two-way calls.
          </p>
        </div>

        <div className="mb-4">
          <h2 className="md:text-xl text-lg text-main1 font-semibold mb-1">
            3. User Registration
          </h2>
          <p className="md:text-base text-sm">
            For registration as user, it would be required to sign up on the
            Website by providing certain personal details and by agreeing to
            provide true, accurate, current, and complete information about
            users’ self as prompted by the registration form. If any information
            provided is untrue, inaccurate, not current, incomplete, or
            suspicious on reasonable grounds, then we may (in addition to any
            other rights or remedies available to us) refuse registration,
            suspend access to all current or future use of the portal and the
            services (or any portion thereof) permanently without any notice.
            Upon signing up on this portal, users’ personal information will be
            registered automatically in our database which will be maintained
            and used by the us for providing our offers, marketing purpose or
            any other communication in accordance with the Privacy Policy. For
            registration purposes, the User shall submit identification
            documents as proof of their personal as well as business identity,
            as regulated by the Department of Telecommunications, Govt. of
            India. The documents MUST be submitted for approval within 3-4 days
            of activation of services. Failure to provide these documents within
            the stipulated timeline will lead to suspension of services to the
            account. In case the documents are still not submitted within 30
            days from the date of suspension, the account will be terminated and
            the display number will be released back to Our telecom partner. In
            such an event, we will not be liable to offer any refund, either in
            full or in part, to the User.
          </p>
        </div>

        <div className="mb-4">
          <h2 className="text-xl text-main1 font-semibold mb-1">
            4. Substantial Delay in Activation of Services:
          </h2>
          <p className="md:text-base text-sm list-disc ">
            We aim to activate user accounts within 7 working days of payment.
            Delays may occur due to late document submission, changes after
            script approval, or regional/international script recordings, which
            may add 7–10 days. National holidays and non-working days are
            excluded from the timeline.
          </p>
        </div>

        <div className="mb-4">
          <h2 className="md:text-xl text-main1  text-lg font-semibold mb-1">
            5. Termination
          </h2>
          <ul className="list-disc pl-5   md:text-base text-sm">
            <li>
              <span className="font-semibold">All payments</span> are to be made
              in favour of{" "}
              <span className="font-semibold">Deetya Soft Pvt. Ltd.</span>
            </li>
            <li>
              <span className="font-semibold">
                Applicable taxes, levies, and charges
              </span>{" "}
              will be charged as per prevailing rates.
            </li>
            <li>
              <span className="font-semibold">Minimum Contract Period</span> is{" "}
              <span className="font-semibold">12 months</span>. If terminated
              early, the customer must pay full charges for the contract period.
            </li>
            <li>
              <span className="font-semibold">Auto-renewal:</span> The contract
              renews automatically unless either party gives a{" "}
              <span className="font-semibold">30-day written notice</span>.
            </li>
            <li>
              <span className="font-semibold">Termination Notice:</span> Minimum{" "}
              <span className="font-semibold">30 days</span> or as per agreed
              payment terms, whichever is less.
            </li>
            <li>
              <span className="font-semibold">Standard delivery period</span> is{" "}
              <span className="font-semibold">2 weeks</span> from CRF
              acceptance, subject to mutually agreed lead times.
            </li>
            <li>
              <span className="font-semibold">Non-payment:</span> If bills
              remain unpaid beyond <span className="font-semibold">4 days</span>
              , services will be deactivated.
            </li>
            <li>
              <span className="font-semibold">
                Toll-Free (18001234277) and DID numbers
              </span>{" "}
              must not be used for{" "}
              <span className="font-semibold">illegal activities</span>. The
              customer is liable for compliance.
            </li>
            <li>
              <span className="font-semibold">DID numbers</span> should{" "}
              <span className="font-semibold">not be used directly</span> in
              campaigns; a mobile or alternate number must be used to receive
              direct calls.
            </li>
          </ul>
        </div>

        <div className="mb-4">
          <h2 className="md:text-xl text-main1 text-lg font-semibold mb-1">
            6. Plans
          </h2>
          <p className="md:text-base text-sm">
            Pre-Paid Plans: Users may renew services within two months of plan
            expiry. Within the first month, full service and the previous number
            can be restored if the number is still available. In the second
            month, renewal is possible without a guarantee of the previous
            number or plan. Plan termination does not affect any rights or
            actions arising before the termination date.
          </p>
        </div>

        <div className="mb-4">
          <h2 className="md:text-xl text-main1 text-lg font-semibold mb-1">
            7. Privacy Guidelines
          </h2>
          <p className="md:text-base text-sm">
            A variety of information, text, graphics, data and other materials
            (“Content”) is available on the portal. The Content available on the
            portal shall be used solely for users’ non-commercial use and/or to
            benefit from the products, services intimated on the portal. No
            right, title or interest in any Content is transferred to user,
            whether as a result of downloading or reproducing such Content or
            otherwise. The Website reserves complete ownership, title and full
            intellectual property rights in all Content uploaded by us. Except
            as expressly authorized by this Terms of use, user may not use,
            alter, copy, distribute, transmit, or derive another work from any
            Content obtained from the Website or the service. Complete
            ownership, title and full intellectual property rights in all
            works/content uploaded by any user on the website belongs to such
            user.
          </p>
        </div>

        <div className="mb-4">
          <h2 className="md:text-xl text-main1 text-lg font-semibold mb-1">
            8.Payment for Services- Toll free and virtual numbers
          </h2>

          <p className="text-base">
            Payment for services shall be made in advance and the user agrees to
            employ any of the electronic or other modes of payment available
            against the fee made through our portal (i.e., net banking, debit
            cards, credit cards, prepaid wallet, or other electronic means). The
            user understands and acknowledges that we are expressly authorized
            to collect, process, facilitate, and remit this fee made
            electronically by the user.
          </p>
          <br />
          <p className="text-base">
            Usage charges will be billed based on actual usage at the end of
            every month and must be cleared within 15 days from the date of
            invoice receipt. Service rental charges are collected in advance on
            a prepaid basis. Invoices submitted by us are subject to inspection
            and verification by the user. Any discrepancies must be reported
            within 7 days of receipt. If required, we will issue a modified
            invoice, and the user shall make payment accordingly. GST at 18%
            will be applicable on all services.
          </p>
          <br />
          <p className="text-base">
            Any payment made in a currency different from that stated on the
            invoice will be converted to the invoice currency at the exchange
            rate on the day of payment receipt. In case of exchange differences
            or totaling errors, Deetya Soft Private Limited reserves the right
            to claim the difference.
          </p>
          <br />
          <p className="text-base">
            Deetya Soft Private Limited is MSME registered (Reg. No.
            DL06D0010571) since 25/08/2018. As per Section 15 of The Micro,
            Small and Medium Enterprises Development Act, 2006, buyers must pay
            MSME suppliers on or before the agreed date, or within 45 days of
            goods/service acceptance if no date is agreed. Delay in payment will
            attract compound interest with monthly rests, at a rate three times
            the RBI bank rate.
          </p>
        </div>

        <div className="mb-4">
          <h2 className="md:text-xl text-main1 text-lg font-semibold mb-1">
            9. Exit Policy and Transfer of Ownership of the Display Number
          </h2>
          <p className="md:text-base text-sm">
            <p className="text-base">
              In case the contract between Deetyasoft and the Buyer has expired
              and the User chooses not to renew or extend services, we may, upon
              request, transfer ownership of the display number to the User. The
              following conditions apply:
            </p>

            <ol className="list-disc pl-6 text-base space-y-1">
              <li>Only virtual mobile numbers shall be transferable.</li>
              <li>
                The ownership of Landline/PSTN/Toll-Free numbers is not
                transferable.
              </li>
              <li>
                We will charge a nominal fee of INR 1000 to assist with the
                transfer of ownership.
              </li>
              <li>
                If the User chooses to initiate the process independently, we
                will terminate and release the number from our end. The User
                must then contact the telecom operator directly to obtain
                ownership. No fee will be charged by us in this case.
              </li>
              <li>
                The User may choose to keep services active until the number
                porting process is complete. In such cases, rental and usage
                charges will apply on a pro-rata basis.
              </li>
              <li>
                We reserve the right to charge up to INR 5000 as a security
                deposit. Any unused amount will be refunded to the User after
                the ownership transfer is complete.
              </li>
            </ol>
          </p>
        </div>

        <div className="mb-4">
          <h2 className="md:text-xl text-main1 text-lg font-semibold mb-1">
            10. Unavailability of Desired or Committed Display Number :
          </h2>
          <p className="md:text-base text-sm">
            This website is owned by Deetya Soft Private Limited. All content,
            designs, trademarks, service marks, trade names, and URLs on the
            website are the property of Deetya Soft or its licensors and are
            protected by intellectual property laws. The website and its content
            are protected by copyright and may belong to Deetya Soft, its
            partners, affiliates, or authorized contributors. Users are not
            permitted to alter or manipulate any images or content on the
            website.
          </p>
        </div>

        <div className="">
          <h2 className="md:text-xl text-main1 text-lg font-semibold mb-1">
            11. Prohibited access of the Portal
          </h2>

          <ul className="list-decimal  pl-6 text-base font-medium space-y-1">
            <li>
              Not disrupt, interfere with, or restrict the portal's use by
              others.
            </li>
            <li>
              Not reverse engineer, decompile, copy, or adapt any part of the
              portal’s software or code.
            </li>
            <li>
              Not modify, misuse, or tamper with any data on the portal,
              including third-party user data.
            </li>
            <li>
              Not reproduce or use portal content for commercial gain without
              prior permission. All rights are reserved.
            </li>
            <li>
              Not use the portal for unlawful purposes and comply with TRAI and
              DoT regulations.
            </li>
            <li>
              Not damage, overload, or impair Deetya Soft’s services, phone
              numbers, servers, or networks.
            </li>
          </ul>
          <div className="space-y-6 text-base">
            <div>
              <h3 className="md:text-xl text-main1 text-lg font-semibold">
                12. Communication
              </h3>
              <p className="text-base">
                Users consent to receive communications from us via email, phone
                calls, and SMS regarding transactions on our portal or website.
                Users must register valid phone numbers and email addresses to
                facilitate such communication. We may also use email to send
                updates, newsletters, service changes, and other information to
                improve our services.
              </p>
            </div>

            <div>
              <h2 className="md:text-xl text-main1 text-lg font-semibold">
                13. Disclaimer of Warranties and Liability
              </h2>
              <p className="text-base">
                Users understand and acknowledge that they are availing our
                services and transacting on our portal at their own risk. We
                shall not be liable for any actions or inactions of the user. We
                expressly disclaim any warranties, whether express or implied,
                regarding quality, accuracy, performance, reliability,
                merchantability, fitness for a specific purpose, legality, or
                safety of products or services displayed or transacted on our
                portal.
              </p>
            </div>

            <div>
              <h2 className="md:text-xl text-main1 text-lg font-semibold">
                14.Indemnity
              </h2>
              <p className="text-base">
                Users agree to indemnify and hold harmless Deetya Soft Private
                Limited and its affiliates, employees, directors, agents,
                vendors, and suppliers from any liability, claims, damages,
                losses, investigations, suits, or expenses (including legal
                fees) arising from their use of the website, obligations under
                these terms, or third-party claims due to user actions,
                violations, or breaches of rights.
              </p>
              <p className="text-base">
                Our total liability under these Terms of Use will be limited
                solely to refunding the amount charged to the user for a
                specific service where the liability has arisen.
              </p>
            </div>

            <div>
              <h2 className="md:text-xl text-main1 text-lg font-semibold">
                15. Limitation of Liability
              </h2>
              <p className="text-base">
                We and our affiliates are not responsible for any consequence
                arising from actions taken based on content on the website.
                Users assume all risk associated with the use of such content.
                We are not liable for any offensive, defamatory, or illegal
                conduct by users or third parties.
              </p>
              <p className="text-base">
                In no event shall we or our affiliates be liable for special,
                indirect, incidental, or consequential damages, including loss
                of use, data, profits, or service substitution, regardless of
                the legal theory or prior knowledge of potential damages.
              </p>
            </div>

            <div>
              <h2 className="md:text-xl text-main1 text-lg font-semibold">
                16. Disclaimer
              </h2>
              <p className="text-base">
                We disclaim all warranties, express or implied, including the
                accuracy and reliability of website content. Users should verify
                any material before relying on it. We are not responsible for
                decisions made based on website materials.
              </p>
              <p className="text-base">
                We do not guarantee that the website will meet user expectations
                or that access will be uninterrupted, timely, or error-free. We
                also do not assure correction of any defects.
              </p>
            </div>

            <div>
              <h2 className="md:text-xl text-main1 text-lg font-semibold">
                17. Governing Law and Dispute Resolution
              </h2>
              <p className="text-base">
                These Terms of Use are governed by the laws of India. Disputes
                will be resolved by a single arbitrator mutually appointed by
                both parties. If they cannot agree, appointment shall follow the
                Arbitration and Conciliation Act, 1996.
              </p>
              <p className="text-base">
                Arbitration proceedings will be confidential and conducted in
                English, with the seat of arbitration in New Delhi.
                Administrative fees will be split equally between both parties,
                and each party shall bear their own legal expenses.
              </p>
            </div>

            <div>
              <h2 className="md:text-xl text-main1 text-lg font-semibold">
                18. Contact Information
              </h2>
              <p className="text-base">
                If you have any questions or concerns regarding these Terms of
                Use or the website, you may contact us at{" "}
                <a
                  href="mailto:Parshan.kumar@gmail.com"
                  className="text-blue-600 underline"
                >
                  Parshan.kumar@gmail.com
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsCondition;
